const tabs = document.querySelector('.data__tabs');

if (tabs) {
    const buttons = tabs.querySelectorAll('.data__tabs-button');
    const tables = tabs.querySelectorAll('.data__tabs-table');

    function setActive(index) {
        buttons.forEach((btn, i) => {
            btn.classList.toggle('active', i === index);
        });

        tables.forEach((table, i) => {
            table.classList.toggle('active', i === index);
        });
    }

    buttons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            setActive(index);
        });
    });

    if (buttons.length) {
        setActive(0);
    }
}